import React from 'react'
import FloatBox from 'components/floatbox';
import styled from 'react-emotion';

const ImageFloatBox = styled(FloatBox)({
  margin: '10px',
  display: 'inline-block',
});
ImageFloatBox.displayName = 'ImageFloatBox';

const Caption = styled('p')({
  textAlign: 'center',
  fontSize: '0.6em',
});
Caption.displayName = 'Caption';

const Image = styled('img')({}, ({ roundedCorners }) => ({
  borderRadius: '10px',
}), ({ width, height }) => ({
  width, height
}));
Image.displayName = 'Image';

const ImageBox = ({ width, height, left, right, image, caption, className, roundedCorners}) => (
  <ImageFloatBox left={left} right={right} className={className}>
    <Image width={width} height={height} alt="" src={image} />
    <Caption>{caption}</Caption>
  </ImageFloatBox>
);

export default ImageBox;



// WEBPACK FOOTER //
// ./src/components/image-box/image-box.js